import React from 'react';
import { Mui, MuiIcons } from '@osu/react-ui';
import ScholarPreferencesForm from '../forms/ScholarPreferencesForm';

/**
 * PreferencesFormWrapper for StudentDashboard
 * Wraps the preferences form with styling and title
 */
function PreferencesFormWrapper({ step, onAction, applicationData }) {
  if (!step.showPreferencesForm) return null;

  return (
    <Mui.Box 
      sx={{ 
        mt: 3,
        p: { xs: 2, sm: 3 },
        backgroundColor: 'background.paper',
        borderRadius: 2,
        border: '2px solid',
        borderColor: '#BA0C2F',
        boxShadow: 3,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: -2,
          left: -2,
          right: -2,
          bottom: -2,
          background: 'linear-gradient(45deg, #BA0C2F, #A7B1B7)',
          borderRadius: 2,
          zIndex: -1
        }
      }}
      role="region"
      aria-labelledby="preferences-form-title"
      tabIndex={-1}
    >
      <Mui.Typography 
        id="preferences-form-title"
        variant="h6" 
        gutterBottom 
        sx={{ 
          mb: 3,
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: { xs: 1, sm: 2 },
          color: '#BA0C2F'
        }}
      >
        <MuiIcons.Assignment />
        Complete Your Program Preferences
      </Mui.Typography>
      
      <ScholarPreferencesForm
        preferences={{}}
        onChange={(preferences) => {
          // Handle preferences change
        }}
        onSubmit={async (preferences) => {
          // Handle form submission with emplid
          if (onAction) {
            const emplid = applicationData?.emplid || applicationData?.honors?.emplid || applicationData?.scholars?.emplid;
            onAction('submit-preferences', { emplid, preferences });
          }
        }}
        onCancel={() => {
          // Handle form cancellation
          if (onAction) {
            onAction('cancel-preferences', {});
          }
        }}
      />
    </Mui.Box>
  );
}

export default PreferencesFormWrapper;